/* eslint-disable */
import { Image } from 'image-js';
import dcraw from 'dcraw';
import { endsWithAny } from '@helpers';

export const read = async (file, onLoad) => {
  const isTiff = endsWithAny(['.tif', '.tiff'], file.name.toLowerCase());
  const reader = new FileReader();

  reader.onload = (object => async e => {
    const buf = new Uint8Array(e.currentTarget.result);
    const metaTmp = dcraw(buf, { verbose: true, identify: true }).split('\n').filter(String);

    const thumbnail = isTiff
      ? { src: (await Image.load(buf)).toDataURL() }
      : new Blob([dcraw(buf, { extractThumbnail: true, useExportMode: true })], { type: 'image/jpeg' });

    const metadata = {};
    metaTmp.forEach(m => {
      const tmp = m.split(/:(.+)/);
      if (tmp.length > 1) {
        metadata[tmp[0].trim().toLowerCase()] = tmp[1].trim();
      }
    });
    onLoad({ thumbnail, metadata, object });
  })(file);

  reader.readAsArrayBuffer(file);
};
